import api from '@/api/login.js'
const state = {
	userInfo: {
		expire_type: 0
	}
}
const mutations = {
	getUserInfoState(state, data) {
		state.userInfo = data
	}
}
const actions = {
	counts({ commit }, params = {}) {
		return api.counts(params)
	},
	login({ commit }, params = {}) {
		return api.login(params)
	},
	getUserInfo({ commit }, params = {}) {
		api.getUserInfo(params, (res) => {
			commit('getUserInfoState', res)
			localStorage.setItem('wework_mod', res.wework_mod) // 转私短信服务模式
		})
	},
	Editpass({ commit }, params = {}) {
		return api.editpass(params)
	},
	openpublicvisible({ commit }, params = {}) {
		api.openpublicvisible(params, (res) => {
		})
	},
	checkwechat({}, params = {}) {
		return api.checkwechat(params)
	},
	loginEditinfo({}, params = {}) {
		return api.loginEditinfo(params)
	},
	plateformActive({}, params = {}) {
		return api.plateformActive(params)
	},
	depositConfirmAPI({}, params = {}) {
		return api.depositConfirmAPI(params)
	}
}
export default {
	namespaced:true,
	state,
	mutations,
	actions,
}